import Vue from 'vue'
import Router from 'vue-router'
import DownloadFiles from '@/components/download/DownloadFiles'
import UploadFilesManager from '@/components/upload-files/UploadFilesManager'
import Content from '@/components/content/Content'
import Home from '@/components/Home'
import PageNotFound from '@/components/layout/PageNotFound'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/download/:id',
      name: 'DownloadFiles',
      component: DownloadFiles
    },
    {
      path: '/receive/:id',
      name: 'UploadFilesManager',
      component: UploadFilesManager
    },
    {
      path: '/vsebina/:content_id',
      name: 'Content',
      component: Content
    },
    {
      path: '/',
      component: Home
    },
    {
      path: '*',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/routerPublic.js